"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderItem = renderItem;
exports._renderItem = _renderItem;
exports.BmItemElement = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _itemRegistry = require("../../../registry/item-registry");

var _itemFactory = require("./item-factory");

var BmItemElement = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmItemElement, _BlueElement);

  var _super = (0, _createSuper2.default)(BmItemElement);

  function BmItemElement() {
    (0, _classCallCheck2.default)(this, BmItemElement);
    return _super.apply(this, arguments);
  }

  return BmItemElement;
}(_element.BlueElement);

exports.BmItemElement = BmItemElement;

function renderItem(item) {
  return (0, _element.guard)([item], function () {
    return (0, _element.cache)((0, _itemFactory.isAvailable)(item) ? _renderItem(item) : null);
  });
}

function _renderItem(info) {
  var itemEngine = (0, _itemRegistry.getItem)(info.type);
  return itemEngine.renderer(info);
}
